export const ESME_FORM_NAME = 'esmeForm';
export const SMSC_FORM_NAME = 'smscForm';
export const DEPLOYMENT_FORM_NAME = 'deploymentForm';

export interface FormStateModel {
  readonly [ESME_FORM_NAME]: {};
  readonly [SMSC_FORM_NAME]: {};
  readonly [DEPLOYMENT_FORM_NAME]: {};
}
